import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentTypeDTO } from 'src/app/pages/dashboards/files-clients/interface/company-document.interface';

@Component({
  selector: 'app-document-types-table',
  templateUrl: './document-types-table.component.html',
  styleUrls: ['./document-types-table.component.scss']
})
export class DocumentTypesTableComponent implements OnInit, OnChanges{
  @Input()public documentTypes: DocumentTypeDTO[];
  @Output()documentTypeToUpdate = new EventEmitter<DocumentTypeDTO>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  public dataSource = new MatTableDataSource<DocumentTypeDTO>([]);
  public columns = [
    'documentName',
    'documentDescription'
  ]

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setDataSource(this.documentTypes);
  }

  public clickUpdateDocumentType(row: DocumentTypeDTO) {
    this.documentTypeToUpdate.emit(row);
  }
 
  private setDataSource(documentTypes: DocumentTypeDTO[]): void{
    this.dataSource.data = documentTypes;
    this.dataSource.paginator = this.paginator;
  }

}
